const copy = {
  errors: {
    unknown: {
      heading: `Looks like something isn't working`,
      description: 'Something went wrong. Try again later',
      link: 'Back to home page',
    },
    notFound: {
      heading: 'Page not found',
      description: 'Please check your URL and try again',
      link: 'Back to home page',
    },
  },
};

export default copy;
